import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';

@Component({
  selector: 'mzic-terms-en',
  imports: [CommonModule],
  templateUrl: './terms-en.component.html',
  styleUrl: './styles.scss',
})
export class TermsEnComponent {}
